export default __webpack_public_path__ + "static/media/1stplace.736a0a3d.svg";